import { FC } from 'react';

import OngoingEventCard, { OngoingEventCardProps } from './EventCard.Ongoing';
import PastEventCard, { PastEventCardProps } from './EventCard.Past';
import UpcomingEventCard, { UpcomingEventCardProps } from './EventCard.Upcoming';

export type GuestsComposition = {
  Ongoing: FC<OngoingEventCardProps>;
  Upcoming: FC<UpcomingEventCardProps>;
  Past: FC<PastEventCardProps>;
};

const EventCard: GuestsComposition = ({ children }): JSX.Element => <>{children}</>;

EventCard.Ongoing = OngoingEventCard;
EventCard.Upcoming = UpcomingEventCard;
EventCard.Past = PastEventCard;

export default EventCard;
